import { render, staticRenderFns } from "./afterSaleWaitConfirmList.vue?vue&type=template&id=4a8fab8a&scoped=true&"
import script from "./afterSaleWaitConfirmList.vue?vue&type=script&lang=js&"
export * from "./afterSaleWaitConfirmList.vue?vue&type=script&lang=js&"
import style0 from "./afterSaleWaitConfirmList.vue?vue&type=style&index=0&id=4a8fab8a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a8fab8a",
  null
  
)

export default component.exports